(function () {
    'use strict';
    var m = angular.module('dao');
    m.factory('manualActionDao', ["http", "manualActionSaveConverter", "actionTagsProcessor", function (http, manualActionSaveConverter, actionTagsProcessor) {
        return {
            create: function (entityType, entityIds, action, secEventIds, noConverter) {
                if (!_(entityIds).isArray()) {
                    entityIds = [entityIds];
                }
                if (secEventIds && !_(secEventIds).isArray()) {
                    secEventIds = [secEventIds];
                } else if (!secEventIds) {
                    secEventIds = [];
                }
                var additionalActions = [
                    'office365_emails_email_restore',
                    'google_mail_email_restore'
                ];
                var payload = {
                    entity_ids: entityIds,
                    entity_type: entityType,
                    data: action,
                    date_trigger: moment().format()
                };
                if (_(payload.data).isObject()) {
                    payload.data.sec_event_ids = secEventIds;
                }
                if (!noConverter) {
                    actionTagsProcessor.generateTags(payload.data, payload.data.attributes);
                }
                if (payload.data.name && payload.data.attributes && additionalActions.indexOf(payload.data.name) !== -1) {
                    payload.data.attributes.release_to_all_recipients = true;
                }
                var createActions = http.post('/api/v1/manual_actions').body(payload);
                // if (!noConverter) {
                //     createActions.bodyConverter(manualActionSaveConverter);
                // }
                return createActions.run();
            },
            createForPolicy: function (policyId, entityType, action) {
                return http.post('/api/v1/manual_action').body({
                    policy_id: policyId,
                    entity_type: entityType,
                    data: action,
                    date_trigger: moment().format()
                }).bodyConverter(manualActionSaveConverter).run();
            }
        };
    }]);
}());